module.exports = __webpack_public_path__ + "img/list-content-search.25bfbeda.png";